module.exports = __webpack_public_path__ + "img/Modern-cosmetics-pop-up.2eacd26f.png";